import * as API from "middleware/api";

export default function listHolidays() {
    return API.executeWithAccessToken("/misc.listHolidays");
}
